import { Tree, TreeItem, TreeItemLayout } from "@fluentui/react-components";
import { TreeNode } from "../../../shared/extractTypes";
import { AppDispatch } from "../../../redux/store";
import { useDispatch } from "react-redux";
import {
  setClientOrPartner,
  setconditionalClientOrPartner,
} from "../../../redux/clientSlice";

// Drops any node marked "hide": true in locate_extract.json, plus the legacy
// Modified/Modified By name check (kept as a safety net for any table whose
// Modified fields aren't marked hidden in the JSON). A branch left with zero
// visible children after filtering is dropped too, so it doesn't render as
// an empty, dead-end expandable entry.
export const filterHiddenTreeNodes = (items: any[]): any[] => {
  return items
    .filter((item: any) => {
      if (item.hide === true) return false;

      const name = (item.name || "").toString().trim();
      const fieldName = (item.fieldName || "").toString().trim();

      return !(
        name === "Modified" ||
        name === "Modified By" ||
        fieldName === "Modified" ||
        fieldName === "ModifiedBy"
      );
    })
    .map((item: any) => {
      if (item.items && Array.isArray(item.items)) {
        return {
          ...item,
          items: filterHiddenTreeNodes(item.items),
        };
      }
      return item;
    })
    .filter(
      (item: any) => !(Array.isArray(item.items) && item.items.length === 0),
    );
};

export const renderTree = (
  data: TreeNode[],
  handleOptionClick: (
    value: string,
    label: string,
    itemType: string,
    data: any,
    datatype: any,
    table: any,
    fieldName?: any,
    node?: any
  ) => void
): React.ReactNode => {
  return data.map((node) => {
    const dispatch: AppDispatch = useDispatch();

    const layoutClick = () => {
      dispatch(setClientOrPartner(node.label));
    };
    if (node.items) {
      return (
        <TreeItem itemType="branch" key={node.label} onClick={layoutClick}>
          <TreeItemLayout>{node.label}</TreeItemLayout>
          <Tree>{renderTree(node.items, handleOptionClick)}</Tree>
        </TreeItem>
      );
    } else {
      return (
        <TreeItem
          itemType="leaf"
          key={node.fieldName}
          onClick={() =>
            handleOptionClick(
              node.fieldName || "",
              node.name || "",
              "leaf",
              data,
              node.datatype,
              node.table,
              node.fieldName,
              node
            )
          }
        >
          <TreeItemLayout>
            {node.table == "UserDefinedValue" ? node.fieldName : node.name}
          </TreeItemLayout>
        </TreeItem>
      );
    }
  });
};

export const renderConditionTree = (
  data: TreeNode[],
  handleConditionOptionClick: (
    value: string,
    label: string,
    itemType: string,
    data: any,
    datatype: any,
    table: any,
    fieldName?: any,
    node?: any
  ) => void
): React.ReactNode => {
  return data.map((node) => {
    const dispatch: AppDispatch = useDispatch();

    const conditionalLayout = () => {
      dispatch(setconditionalClientOrPartner(node.label));
    };
    if (node.items) {
      return (
        <TreeItem
          itemType="branch"
          key={node.label}
          onClick={conditionalLayout}
        >
          <TreeItemLayout>{node.label}</TreeItemLayout>
          <Tree>
            {renderConditionTree(node.items, handleConditionOptionClick)}
          </Tree>
        </TreeItem>
      );
    } else {
      return (
        <TreeItem
          itemType="leaf"
          key={node.fieldName}
          onClick={() =>
            handleConditionOptionClick(
              node.fieldName || "",
              node.name || "",
              "leaf",
              data,
              node.datatype,
              node.table,
              node.fieldName,
              node
            )
          }
        >
          <TreeItemLayout>{node.name}</TreeItemLayout>
        </TreeItem>
      );
    }
  });
};
